module.exports = __webpack_public_path__ + "static/l3-efaecef9ff93f3654550a9c994c47b71.png";